class utils {
  static px(value) {
    return `${value}px`;
  }

  static url(value) {
    if(!value || value === 'none') return 'none';
    return `url(${value})`;
  }

  static proc(value) {
    return `${value}%`;
  }

  static pascalCase(value) {
  }
}

export const pascalCase = (value) => value[0].toUpperCase() + value.replace(/[-_](.)/g, (match, char) => char.toUpperCase()).slice(1);

export default utils;
